import { Box, Stack } from '@montugroup/design-system';
import { styled } from '@mui/material';

export const PriceTierRow = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  flexDirection: 'row',
  gap: theme.spacing(1),
}));

export const PriceTierRange = styled(Box)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));
